'use client'

import { useMemo } from 'react'
import { useTheme } from 'next-themes'
import { useTranslations } from 'next-intl'
import { Check, Moon, Sun } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'

const ThemeModeSwitcher = () => {
  const { theme, setTheme } = useTheme()
  const t = useTranslations()

  const themeOptions = useMemo(() => {
    return [
      { value: 'light', label: t('light') },
      { value: 'dark', label: t('dark') },
      { value: 'system', label: t('system') }
    ]
  }, [t])

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Sun className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90" />
          <Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {themeOptions.map(option => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => setTheme(option.value)}
            className="flex flex-row justify-between gap-2">
            <span>{option.label}</span>
            {theme === option.value && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ThemeModeSwitcher
